export default __webpack_public_path__ + "static/media/icon2-m.1102a58a.png";